import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, MapPinIcon, UserCheckIcon, ActivityIcon, CalendarCheckIcon, HeartPulseIcon, ZapIcon, SparklesIcon } from 'lucide-react';
export function ReviewsSection() {
  const trustCards = [{
    icon: StarIcon,
    title: 'Over 300 5-Star Reviews',
    desc: 'Verified patient feedback from the Bloomfield Hills community.'
  }, {
    icon: MapPinIcon,
    title: 'Trusted Bloomfield Hills Office',
    desc: 'Conveniently located at 6405 Telegraph Road, Bloomfield Hills.'
  }, {
    icon: ZapIcon,
    title: 'Aspen Pinnacle Laser Therapy',
    desc: 'Professional Class IV laser equipment for focused, modern care.'
  }, {
    icon: UserCheckIcon,
    title: 'Trusted Chiropractic Care',
    desc: 'Dr. Dan McAleer leads a team focused on patient outcomes.'
  }, {
    icon: ActivityIcon,
    title: 'Multiple Therapies Available',
    desc: 'Chiropractic, massage, spinal decompression, and laser therapy under one roof.'
  }, {
    icon: SparklesIcon,
    title: 'Personalized Care Plans',
    desc: 'Recommendations built around your symptoms, goals, and lifestyle.'
  }];
  return <section className="py-20 md:py-24 bg-white" data-id="element-220">
      <div className="w-full max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-221">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-14 max-w-3xl mx-auto" data-id="element-222">
          <div className="flex justify-center gap-1 mb-4" data-id="element-223">
            {[1, 2, 3, 4, 5].map(i => <StarIcon key={i} className="w-6 h-6 text-amber-400 fill-current" data-id="element-224" />)}
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-brand-navy mb-5 leading-tight" data-id="element-225">
            Why Patients Choose Paragon Chiropractic
          </h2>
          <p className="text-base md:text-lg text-gray-700 leading-relaxed" data-id="element-226">
            A trusted Bloomfield Hills team focused on personalized,
            evidence-informed care.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5" data-id="element-227">
          {trustCards.map((card, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: idx * 0.08
        }} className="bg-white border-2 border-gray-200 rounded-2xl p-6 md:p-7 hover:border-brand-teal/40 hover:shadow-md transition-all duration-300" data-id="element-228">
              <div className="w-12 h-12 bg-brand-teal rounded-xl flex items-center justify-center mb-4 text-white shadow-md shadow-brand-teal/20" data-id="element-229">
                <card.icon className="w-6 h-6" data-id="element-230" />
              </div>
              <h3 className="text-lg font-black text-brand-navy mb-2 leading-tight" data-id="element-231">
                {card.title}
              </h3>
              <p className="text-sm text-gray-700 leading-relaxed" data-id="element-232">
                {card.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}